import { Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';

const NoClasses = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between border border-gray-300 rounded-lg p-6 bg-white max-w-5xl mx-auto my-5">
      <div className="flex items-start space-x-4">
        <Calendar className='mt-1'/>
        <div>
          <h4 className="text-lg font-medium text-gray-800">No tienes clases reservadas</h4>
          <p className="text-sm text-gray-600 mt-1">¿Estás listo para empezar? Reserva una clase.</p>
        </div>
      </div>
      <div className="mt-4 md:mt-0 flex flex-col sm:flex-row gap-3 ">
        <Link
          to="/clases"
          className="bg-holos-dark text-white text-sm uppercase px-6 py-2 rounded text-center hover:bg-holos-dark/80"
        >
          Reservar Clases
        </Link>
        <Link
          to="/clases-online"
          className="bg-holos-dark text-white text-sm uppercase px-6 py-2 rounded text-center hover:bg-holos-dark/80"
        >
          Videos On-Demand
        </Link>
      </div>
    </div>
  );
};

export default NoClasses;
